module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-input"
  }, [_vm._l((_vm.fields), function(tag) {
    return [(tag.type === _vm.TagType.multiselect || tag.type === _vm.TagType.select) ? [_c('tag-input', {
      key: tag.id,
      attrs: {
        "label": tag.label,
        "options": tag.options,
        "type": tag.type
      },
      model: {
        value: (_vm.value[tag.id]),
        callback: function($$v) {
          _vm.$set(_vm.value, tag.id, $$v)
        },
        expression: "value[tag.id]"
      }
    })] : (tag.type === _vm.TagType.boolean) ? [_c('fieldset', {
      key: tag.id
    }, [_c('input-yes-no', {
      attrs: {
        "label": tag.label
      },
      model: {
        value: (_vm.value[tag.id]),
        callback: function($$v) {
          _vm.$set(_vm.value, tag.id, $$v)
        },
        expression: "value[tag.id]"
      }
    })], 1)] : (tag.type === _vm.TagType.text) ? [_c('fieldset', {
      key: tag.id
    }, [_c('input-with-validation', {
      attrs: {
        "type": "text",
        "label": tag.label
      },
      model: {
        value: (_vm.value[tag.id]),
        callback: function($$v) {
          _vm.$set(_vm.value, tag.id, $$v)
        },
        expression: "value[tag.id]"
      }
    })], 1)] : (tag.type === _vm.TagType.longtext) ? [_c('fieldset', {
      key: tag.id
    }, [_c('input-with-validation', {
      attrs: {
        "type": "textarea",
        "label": tag.label
      },
      model: {
        value: (_vm.value[tag.id]),
        callback: function($$v) {
          _vm.$set(_vm.value, tag.id, $$v)
        },
        expression: "value[tag.id]"
      }
    })], 1)] : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1644c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tagsInput.vue
// module id = 608
// module chunks = 0